import { DecimalPipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  standalone: true,
  selector: 'ct-lib-progress-ring',
  templateUrl: './progress-ring.component.html',
  styleUrls: ['./progress-ring.component.scss'],
  imports: [DecimalPipe],
})
export class ProgressRingComponent implements OnInit {
  @Input() value = 0;
  @Input() label = true;
  @Input() color: string;

  

  ngOnInit(): void {
    if (this.value < 0) this.value = 0;
    if (this.value > 100) this.value = 100;
  }
}
